import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=483b7cba&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483b7cba')) {
      api.createRecord('483b7cba', component.options)
    } else {
      api.reload('483b7cba', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=483b7cba&", function () {
      api.rerender('483b7cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bfTI6yxuoN0p/JS/comp/ErrorMessage.vue"
export default component.exports